import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"
import ChangePassword from "pages/Authentication/ChangePassword"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//Grievances Mgt
import Grievances from "pages/Grievances/Grievances"
import DisciplinarySetup from "pages/Grievances/DisciplinarySetup"
import GrievanceCases from "pages/Grievances/GrievanceCases"
import GrievanceDetails from "pages/Grievances/GrievanceDetails"
import AddGrievanceCase from "pages/Grievances/AddGrievances"
import GrievanceCasesToAnswer from "pages/Grievances/GrievanceCasesToAnswer"

//Leave Mgt
import Leave from "pages/Leave/Leave"
import AddLeaveRequest from "pages/Leave/AddLeaveRequest"
import LeaveRequests from "pages/Leave/LeaveRequests"
import LeaveRequestDetails from './../pages/Leave/LeaveRequestDetails';
import LeaveRequestApproved from "pages/Leave/LeaveRequestApproved"
import LeaveApprovals from "pages/Approvals/LeaveApprovals"
import Approvals from "pages/Approvals/Approvals"
import ApproveLeaveRequest from "pages/Leave/ApproveLeaveRequest"
import LeaveRequestsPosted from "pages/Leave/LeaveRequestsPosted"
import ViewLeaveReport from "pages/Leave/ViewLeaveReport"
import SubmittedLeaveRequests from "pages/Leave/SubmittedLeaveRequests"

//Performance Mgt
import Appraisal from "pages/Appraisals/Appraisal"
import IPAs from "pages/Appraisals/IPAs"
import IPAAdd from "pages/Appraisals/IPAAdd"
import IPADetails from "pages/Appraisals/IPADetails"
import PAs from "pages/Appraisals/PAs"
import PADetails from "pages/Appraisals/PADetails"
import ApproveIPA from "pages/Appraisals/ApproveIPA"
import RequestApproved from "pages/Approvals/RequestApproved"
import RequestRejected from "pages/Approvals/RequestRejected"
import FullTermPAs from "pages/Appraisals/FullTermPAs"
import FullTermPADetails from "pages/Appraisals/FullTermPADetails"
import ApproveFullTermsDetails from "pages/Appraisals/ApproveFullTermsDetails"
import AppraisePAs from "pages/Appraisals/AppraisePAs"
import ApproveMidterms from "pages/Appraisals/ApproveMidterms"
import ApproveFullTermsList from "pages/Appraisals/ApproveFullTermsList"
import PIPs from "pages/Appraisals/PIPs"
import PIPAdd from "pages/Appraisals/PIPAdd"
import PIPDetails from "pages/Appraisals/PIPDetails"
import ApprovePIPs from "pages/Appraisals/ApprovePIPs"

//Training Mgt
import Training from "pages/Training/Training"
import PDP from "pages/Training/PDP"
import TrainingPlan from "pages/Training/TrainingPlan"
import ApprovePDP from "pages/Training/ApprovePDP"

//Exit Mgt
import Exit from "pages/Exit/Exit"
import AddExitInterview from "pages/Exit/AddExitInterview"
import ExitApprovals from "pages/Exit/ExitApprovals"
import ExitInterviewSubmitted from "pages/Exit/ExitInterviewSubmitted"
import ExitInterviews from "pages/Exit/ExitInterviews"
import ExitInterviewDetails from "pages/Exit/ExitInterviewDetails"
import Handover from "pages/Exit/HandOver"

//recruitment
import AddRecruitmentRequisition from "pages/Recruitment/AddRecruitmentRequisition"
import Recruitment from "pages/Recruitment/Recruitment"
import RecruitmentRequisitions from "pages/Recruitment/RecruitmentRequisitions"
import RecruitmentRequisitionDetails from "pages/Recruitment/RecruitmentRequisitionDetails"
import RecruitmentApplicants from "pages/Recruitment/RecruitmentApplicants"
import ApproveRecruitmentRequisition from "pages/Recruitment/ApproveRecruitmentRequisition"
import SetServer from "pages/Setup/SetServer"

//Purchase Mgt
import Purchases from "pages/Purchases/Purchases"
import PurchaseRequisitions from "pages/Purchases/PurchaseRequisitions"
import AddPurchaseRequisition from "pages/Purchases/AddPurchaseRequisitions"
import PurchaseRequisitionDetails from "pages/Purchases/PurchaseRequisitionDetails"
import ApprovePurchaseRequisition from "pages/Purchases/ApprovePurchaseRequisitionsDetails"
import PurchaseApprovals from "pages/Approvals/PurchaseApprovals"
import ApprovedPurchaseRequisitions from "pages/Purchases/ApprovedPurchaseRequisitions"
import SubmittedPurchaseRequisitions from "pages/Purchases/SubmittedPurchaseRequisitions"

//Payments Mgt
import PaymentRequisitions from "pages/Payments/PaymentRequisitions"
import AddPaymentRequisition from "pages/Payments/AddPaymentRequisition"
import PaymentRequisitionDetails from "pages/Payments/PaymentRequisitionDetails"
import ApprovePaymentRequisition from "pages/Payments/ApprovePaymentRequisition"
import ApprovedPaymentRequisitions from "pages/Payments/ApprovedPaymentRequisitions"
import Payments from "pages/Payments/Payments"
import SubmittedPaymentRequisitions from "pages/Payments/SubmittedPaymentRequisitions"
import PaymentApprovals from "pages/Approvals/PaymentApprovals"

//Fleet Mgt
import FleetRequisitions from "pages/Fleet/FleetRequisitions"
import Fleet from "pages/Fleet/Fleet"

//Recruitment
import PublicApplicantsLogin from "pages/Recruitment/PublicApplicantsLogin"
import PublicApplicantsRegister from "pages/Recruitment/PublicApplicantsRegistration"
import Applications from "pages/Recruitment/PublicApplicantsLandingPage"
import VacancyDetails from "pages/Recruitment/PublicVacancyDetails"
import CreateApplication from "../pages/Recruitment/CreateApplication"
import CreateApplicationDetails from "pages/Recruitment/CreateApplicationDetails"
import MyApplications from "pages/Recruitment/MyApplications"

//Timesheets
import Timesheets from "pages/Timesheets/Timesheets"
import MyTimesheets from "pages/Timesheets/MyTimesheets"
import TimesheetApprovals from "pages/Approvals/TimesheetApprovals"
import ApproveTimesheetRequest from "pages/Timesheets/ApproveTimesheetRequest"
import ApprovedTimesheets from "pages/Timesheets/ApprovedTimesheets"
import MyPendingTimesheets from "pages/Timesheets/MyPendingTimesheets"
import MyRejectedTimesheets from "pages/Timesheets/MyRejectedTimesheets"
import SubmittedTimesheetsUser from "pages/Timesheets/SubmittedTimesheetsUser"
import ViewSubmittedTimesheet from "pages/Timesheets/ViewSubmittedTimesheets"

//Utility
import PagesComingsoon from "pages/Utility/pages-comingsoon"
import Dashboard from "../pages/Dashboard/index"
import Users from "pages/SystemUsers/Users"
import Companies from "pages/SystemUsers/Companies"


const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/coming-soon", component: PagesComingsoon},
  
  { path: "/grievances", component: Grievances },
  { path: "/disciplinary-setup", component: DisciplinarySetup },
  { path: "/grievance-cases", component: GrievanceCases },
  { path: "/grievance-details/:id", component: GrievanceDetails },
  { path: "/raise-grievance", component: AddGrievanceCase },
  { path: "/cases-to-answer", component: GrievanceCasesToAnswer },

  //Leave Management
  { path: "/leave", component: Leave },
  { path: "/add-leave-request", component: AddLeaveRequest },
  { path: "/leave-requests", component: LeaveRequests },
  { path: "/leave-request-details/:id", component: LeaveRequestDetails },
  { path: "/leave-request-approved/:no", component: LeaveRequestApproved },
  { path: "/approve-leave-request/:no/:id", component: ApproveLeaveRequest },
  { path: "/posted-leave-requests", component: LeaveRequestsPosted },
  { path: "/leave-approvals", component: LeaveApprovals},
  { path: "/submitted-leave-requests", component: SubmittedLeaveRequests },

  { path: "/approvals", component: Approvals },
  { path: "/approved/:no", component: RequestApproved },
  { path: "/rejected/:no", component: RequestRejected },
  
  //Performance Management
  { path: "/appraisals", component: Appraisal},
  { path: "/individual-performance-agreement", component: IPAs},
  { path: "/individual-performance-agreement-details/:id", component: IPADetails},
  { path: "/add-individual-performance-agreement", component: IPAAdd},
  { path: "/performance-appraisals", component: PAs},
  { path: "/appraise-performance-appraisals", component: AppraisePAs},
  { path: "/full-performance-appraisals", component: FullTermPAs},
  { path: "/staff-performance-appraisal/:id", component: PADetails},
  { path: "/staff-fullterm-performance-appraisal/:id", component: FullTermPADetails},
  { path: "/approve-individual-performance-agreement/:no/:id", component: ApproveIPA},
  { path: "/approve-midterms/:no/:id", component: ApproveMidterms},
  { path: "/approve-fullterm-appraisals-list", component: ApproveFullTermsList},
  { path: "/approve-fullterm-appraisals-details/:id", component: ApproveFullTermsDetails},
  { path: "/performance-improvement-plans", component: PIPs},
  { path: "/add-performance-improvement-plan", component: PIPAdd},
  { path: "/performance-improvement-plan/:id", component: PIPDetails},
  { path: "/approve-performance-improvement-plan/:no/", component: ApprovePIPs},

  { path: "/training", component: Training },
  { path: "/personal-development-plan", component: PDP },
  { path: "/approve-personal-development-plan/:no/:id", component: ApprovePDP },
  { path: "/training-plan", component: TrainingPlan },

  //Exit Management
  { path: "/exit", component: Exit },
  { path: "/create-exit-interview", component: AddExitInterview },
  { path: "/exit-interview-submitted", component: ExitInterviewSubmitted },
  { path: "/exit-approvals", component: ExitApprovals },
  { path: "/staff-handover", component: Handover },
  { path: "/exit-interviews", component: ExitInterviews },
  { path: "/exit-interview-details/:id", component: ExitInterviewDetails },

  //Recruitment Management
  { path: "/recruitment", component: Recruitment },
  { path: "/create-recruitment-requisition", component: AddRecruitmentRequisition },
  { path: "/recruitment-requisitions", component: RecruitmentRequisitions },
  { path: "/recruitment-requisition-details/:id", component: RecruitmentRequisitionDetails },
  { path: "/recruitment-applicants", component: RecruitmentApplicants },
  { path: "/approve-recruitment-requisition/:no/:id", component: ApproveRecruitmentRequisition },

  //Purchase Management
  { path: "/purchases", component: Purchases },
  { path: "/purchase-requisitions", component: PurchaseRequisitions },
  { path: "/create-purchase-requisition", component: AddPurchaseRequisition },
  { path: "/purchase-requisition-details/:id", component: PurchaseRequisitionDetails },
  { path: "/submitted-purchase-requisitions", component: SubmittedPurchaseRequisitions },
  { path: "/approve-purchase-requisition/:no/:id", component: ApprovePurchaseRequisition },
  { path: "/purchase-approvals", component: PurchaseApprovals},
  { path: "/approved-purchase-requisitions", component: ApprovedPurchaseRequisitions},

  //Payments Management
  { path: "/payments", component: Payments },
  { path: "/payment-requisitions", component: PaymentRequisitions },
  { path: "/payment-approvals", component: PaymentApprovals },
  { path: "/submitted-payment-requisitions", component: SubmittedPaymentRequisitions },
  { path: "/create-payment-requisition", component: AddPaymentRequisition },
  { path: "/payment-requisition-details/:id", component: PaymentRequisitionDetails },
  { path: "/approve-payment-requisition/:no/:id", component: ApprovePaymentRequisition },
  { path: "/approved-payment-requisitions", component: ApprovedPaymentRequisitions},

  //Fleet Management
  { path: "/fleet", component: Fleet },
  { path: "/fleet-requisitions", component: FleetRequisitions },
  // { path: "/create-payment-requisition", component: AddPaymentRequisition },
  // { path: "/payment-requisition-details/:id", component: PaymentRequisitionDetails },
  // { path: "/approve-payment-requisition/:id/:nno", component: ApprovePaymentRequisition },
  // { path: "/approved-payment-requisition/:id/:nno", component: ApprovedPaymentRequisition },

  // Timesheets
  { path: "/timesheets", component: Timesheets },
  { path: "/my-timesheets", component: MyTimesheets },
  { path: "/timesheet-approvals", component: TimesheetApprovals },
  { path: "/approved-timesheets", component: ApprovedTimesheets },
  { path: "/approve-timesheet-request/:approvalEntryNo", component: ApproveTimesheetRequest },
  //{ path: "/my-submitted-timesheets", component: MyPendingTimesheets },
  { path: "/my-rejected-timesheets", component: MyRejectedTimesheets },
  { path: "/my-submitted-timesheets", component: SubmittedTimesheetsUser },
  { path: "/view-timesheet-request/:approvalEntryNo", component: ViewSubmittedTimesheet },


  // profile
  { path: "/profile", component: UserProfile },
  { path: "/system-users", component: Users },
  { path: "/companies", component: Companies},

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password", component: ChangePassword },
  { path: "/register", component: Register },
  { path: "/view-leave-report", component: ViewLeaveReport },
  { path: "/setup", component: SetServer },
  { path: "/applicants-login", component: PublicApplicantsLogin },
  { path: "/applicants-registration", component: PublicApplicantsRegister },
]

const applicationRoutes = [
  { path: "/applications", component: Applications },
  { path: "/vacancy-details/:id", component: VacancyDetails },
  { path: "/create-application/:id", component: CreateApplication },
  { path: "/create-application-details/:id", component: CreateApplicationDetails },
  { path: "/my-applications", component: MyApplications},
]

export { publicRoutes, authProtectedRoutes, applicationRoutes }
